import om from "../om.jpg";
import "./loader.css";

export const Loader = () => {
  return (
    <div className="loader">
      <img src={om} alt="Loader" />
    </div>
  );
};
